module.exports = __webpack_public_path__ + "img/HorseRelease5.23fb21ba.jpg";